import safe from'../../../pip/library/pi-safe/pi-safe.js';
import tt from'../../../pip/library/pi-tt/pi-tt.js';

import { IAHPConfiguration } from './configuration';

export interface IMiddlewareConfiguration {
  interceptors: {
    configuration: string[];
  };
}

export interface IMiddlewareScript {
  run(configuration: IAHPConfiguration): Promise<IAHPConfiguration>;
}

export class Middleware {
  run(configuration: IAHPConfiguration) {
    const middlewareURIs = tt
      .getWithDefault([], 'middleware.interceptors.configuration', configuration)
      .filter(tt.identity);

    if (middlewareURIs == null) {
      return Promise.resolve(configuration);
    }

    const middlewareScripts = tt.map((middlewareURI) => {
      return this.__importScript(middlewareURI);
    }, middlewareURIs);

    return Promise.all(middlewareScripts).then((middlewareScripts) => {
      return tt.reduce(
        (configuration: Promise<IAHPConfiguration>, middlewareScript) => {
          return configuration.then((configuration) => this.__runScript(configuration, middlewareScript));
        },
        Promise.resolve(configuration),
        middlewareScripts
      );
    });
  }

  private __importScript(uri: string): Promise<IMiddlewareScript> {
    return import(safe.uri(uri));
  }

  private __runScript(
    configuration: IAHPConfiguration,
    middlewareScript: IMiddlewareScript
  ): Promise<IAHPConfiguration> {
    return tt.is(Function, middlewareScript.run) ? middlewareScript.run(configuration) : Promise.resolve(configuration);
  }
}
